/** Device-only UI text preference. Absolute role sizes never scale the game canvas. */
const STORAGE_KEY = 'unige.ui-text.v1';
const SIZES = [{ id: 'small', name: '작게' }, { id: 'default', name: '기본' }, { id: 'large', name: '크게' }];
let selected = 'default';
let ready = false;
let storageStatus = '기본 설정';

function normalize(value) { return SIZES.some((size) => size.id === value) ? value : 'default'; }

function apply(value) {
  selected = normalize(value);
  document.documentElement.dataset.uiText = selected;
  for (const button of document.querySelectorAll('[data-ui-text-choice]')) {
    const on = button.dataset.uiTextChoice === selected;
    button.classList.toggle('on', on);
    button.setAttribute('aria-pressed', String(on));
  }
  const output = document.getElementById('ui-text-current');
  if (output) output.textContent = `${SIZES.find((size) => size.id === selected).name} · ${storageStatus}`;
  window.dispatchEvent(new CustomEvent('unige:text-size'));
  return selected;
}

export function setTextSize(value) {
  const next = normalize(value);
  try { localStorage.setItem(STORAGE_KEY, next); storageStatus = '이 기기에 저장됨'; }
  catch { storageStatus = '이 탭에만 적용 · 저장 불가'; }
  return apply(next);
}

export function readabilityControls() {
  return `<div class="readability-options" role="group" aria-label="글자 크기">${SIZES.map((size) =>
    `<button type="button" data-ui-text-choice="${size.id}" class="${selected === size.id ? 'on' : ''}" aria-pressed="${selected === size.id}" onclick="act.textSize('${size.id}')">${size.name}</button>`).join('')}</div>
    <p class="muted">메뉴와 안내 글자만 바뀐다. 월드와 캐릭터 크기는 그대로다.</p>
    <output id="ui-text-current" aria-live="polite">${SIZES.find((size) => size.id === selected).name} · ${storageStatus}</output>`;
}

/** Share the dock's measured-height contract with skills and the upper HUD. */
export function observeUiHeight(element, property, bottom = false, Observer = window.ResizeObserver) {
  const measure = () => {
    const rect = element.getBoundingClientRect();
    const pixels = rect.height > 0 ? Math.ceil(bottom ? rect.bottom : rect.height) : 0;
    document.documentElement.style.setProperty(property, `${pixels}px`);
  };
  if (Observer) new Observer(measure).observe(element);
  window.addEventListener('resize', measure);
  window.addEventListener('unige:text-size', measure);
  document.fonts?.ready?.then(measure).catch(() => {});
  measure();
  return measure;
}

export function initReadability() {
  if (ready) return;
  ready = true;
  let saved = 'default';
  try {
    saved = localStorage.getItem(STORAGE_KEY);
    storageStatus = SIZES.some((size) => size.id === saved) ? '이 기기에 저장됨' : '기본 설정';
  } catch { storageStatus = '이 탭에만 적용 · 저장 불가'; }
  apply(saved);
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY || event.key === null) {
      storageStatus = SIZES.some((size) => size.id === event.newValue) ? '이 기기에 저장됨' : '기본 설정';
      apply(event.newValue);
    }
  });
  const top = document.getElementById('topleft');
  if (top) observeUiHeight(top, '--hud-left-bottom', true);
}
